import { useEffect, useState } from "react";
import LoadingState from "./loading-state";

type LoadingStateType = typeof LoadingState[keyof typeof LoadingState];

const useLoadingState = (
  loadingState: LoadingStateType,
  onSuccess: () => void,
  onFailure?: () => void,
  onProgress?: () => void
): void => {
  const [isInProgress, setInProgress] = useState(false);

  useEffect(() => {
    switch (loadingState) {
      case LoadingState.IN_PROGRESS:
        setInProgress(true);
        if (onProgress) {
          onProgress();
        }
        break;
      case LoadingState.COMPLETED:
        if (isInProgress) {
          setInProgress(false);
          onSuccess();
        }
        break;
      case LoadingState.FAILED:
        if (isInProgress) {
          setInProgress(false);
          if (onFailure) {
            onFailure();
          }
        }
        break;
    }
  }, [loadingState]);
};

export default useLoadingState;
